import { createCanBoundTo } from '@casl/react';
import { ability as currentAbility } from './ability';

export default createCanBoundTo(currentAbility);
